import {
  createValidation,
  validatorRequired,
} from '../../utils/formValidators';
import { formTsAgreementTransactionFields } from '../../constants/forms/formTsAgreementTransaction';

export default createValidation([
  {
    name: formTsAgreementTransactionFields.PRICE,
    validators: (field) => validatorRequired()(field),
  },
]);
